module.exports = __webpack_public_path__ + "fonts/la-regular-400.cf246e2.ttf";